const roles = {
  ROLE_PLAYER: 'player',
  ROLE_HOST: 'gamehost'
};

export default roles;


// WEBPACK FOOTER //
// ./src/config/roles.js